import { useTranslation } from "react-i18next";
import { cn } from "utils";
import { Icon } from "components/icon/Icon";
import { Badge } from "components/ui/badge";

export type SalesDataSource = "mediaControl" | "amazon";

// Full key literals (not interpolated) so the static i18next extractor keeps
// them.
const SOURCE_NAME_KEYS: Record<SalesDataSource, string> = {
  mediaControl: "productDetails:salesData.source.mediaControl",
  amazon: "productDetails:salesData.source.amazon",
};

// Media Control figures include projections; label the source at point of use.
export const SourceChip = ({
  source,
  className,
}: {
  source: SalesDataSource;
  className?: string;
}) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <Badge
      variant="secondary"
      className={cn("min-w-0 gap-1.5 px-2 py-0.5", className)}
      data-testid={`source-chip-${source}`}
    >
      <Icon name="database" size="xsmall" iconClassName="text-secondary-500" />
      {t("productDetails:salesData.source.label", {
        source: t(SOURCE_NAME_KEYS[source]),
      })}
    </Badge>
  );
};
